import React from "react";

// Components
import { CompanyDetail } from "shared/components/company";
import Overlay from "shared/components/overlay/Overlay";
import SlidingPanel from "shared/components/sliding-panel/SlidingPanel";

// Styles
import styles from './CompanyDetailPanel.module.scss';

const CompanyDetailPanel = ({ afterSave, company, isActive=false, onClose }) => {
    return (
        <div className={ styles.wrapper }>
            <SlidingPanel className={ styles.panel } isActive={ isActive }>
                { company &&
                    <div className={ styles.wrapper }>
                        <article className={ styles.detail }>
                            <CompanyDetail
                                afterSave={ afterSave }
                                onClose={ onClose }
                                company={ company }
                            />
                        </article>
                    </div>
                }
            </SlidingPanel>

            <Overlay isActive={ isActive } isContained onClick={ onClose } />
        </div>
    )
}

export default CompanyDetailPanel;
